import i18next from "i18next"
import moment from "moment"
i18next.loadNamespaces("translation")

export function formatDay(datetime: string | undefined) {
  if (!datetime) return null
  const params: any[] = datetime.split("-")
  const date = new Date(params[0], params[1] - 1, params[2])
  let wDay = date.toLocaleDateString("en", { weekday: "long" })
  wDay = `${wDay.charAt(0).toUpperCase()}${wDay.slice(1).toLowerCase()}`
  const weekDay = i18next.t(`date.days.long.${wDay}`)
  const day = date.getDate()
  const month = i18next.t(
    `date.months.short.${Object.keys(CALENDAR_MONTHS)[date.getMonth()]}`
  )
  return `${weekDay} ${day} ${month}`
}

const CALENDAR_MONTHS: { [key: string]: string } = {
  January: "Jan",
  February: "Feb",
  March: "Mar",
  April: "Apr",
  May: "May",
  June: "Jun",
  July: "Jul",
  August: "Aug",
  September: "Sep",
  October: "Oct",
  November: "Nov",
  December: "Dec",
}

export function formatTimeToCurrentTimezone(time: string) {
  return moment(new Date(time)).format("HH:mm")
}
